let selectedFilters = [];
let categoryFilters = [];
let concernFilters = [];
let ingredientsFilters = [];

class BlogFilterDrawer {
    constructor() {
        this.overlay = document.querySelector('.filter-drawer-overlay');
        this.drawer = document.querySelector('.filter-drawer');
        this.drawerTitle = document.querySelector('.filter-drawer-title');
        this.closeButton = document.querySelector('.filter-drawer-close');
        this.filterTriggers = document.querySelectorAll('[data-filter-trigger]');
        this.filterGroups = document.querySelectorAll('[data-filter-group]');
        this.allButton = document.querySelector('.filter-all');
        this.articlesContainer = document.querySelector('.blog-articles'); 

        this.mutationObserver = null;

        this.init();
    }

    init() {
        this.loadFiltersFromURL();
        this.initTriggers();
        this.initClose();
        this.updateActiveStates();
        this.setupInfiniteScrollObserver();
    }

    initTriggers() {
        this.filterTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                const filterType = trigger.dataset.filterTrigger;
                const title = trigger.querySelector('span')?.textContent || 'Filters';
                this.openDrawer(filterType, title);
            });
        });
    }

    openDrawer(filterType, title) {
        this.drawerTitle.textContent = title;
        this.filterGroups.forEach(group => group.style.display = 'none');
        const selectedGroup = document.querySelector(`[data-filter-group="${filterType}"]`);
        if (selectedGroup) selectedGroup.style.display = 'block';

        this.overlay.classList.add('active');
        document.body.classList.add('filter-drawer-open');
    }

    closeDrawer() {
        this.overlay.classList.remove('active');
        document.body.classList.remove('filter-drawer-open');
    }

    initClose() {
        if (this.closeButton) this.closeButton.addEventListener('click', () => this.closeDrawer());

        if (this.overlay) {
            this.overlay.addEventListener('click', (e) => {
                if (e.target === this.overlay) this.closeDrawer();
            });
        }

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.overlay.classList.contains('active')) this.closeDrawer();
        });
    }

    updateActiveStates() {
        this.filterTriggers.forEach(trigger => {
            const filterType = trigger.dataset.filterTrigger;
            const filterGroup = document.querySelector(`[data-filter-group="${filterType}"]`);
            
            if (!filterGroup) return;

            filterGroup.addEventListener('click', (e) => {
                const item = e.target.closest('.filter-drawer-item');
                if (!item) return;

                const checkbox = item.querySelector('input[type="checkbox"]');
                if (!checkbox) return;

                 e.preventDefault();

                    checkbox.checked = !checkbox.checked;
                

                const value = checkbox.value;
                if (!value) return;

                const index = selectedFilters.indexOf(value);

                if (checkbox.checked) {
                    if (index === -1) {
                        selectedFilters.push(value);
                        item.classList.add('active');
                    }
                } else {
                    if (index !== -1) {
                        selectedFilters.splice(index, 1);
                        item.classList.remove('active');
                    }
                }

                const filterDrawerGroup = item.closest('.filter-drawer-group');
                if (!filterDrawerGroup) return;
                const groupName = filterDrawerGroup.dataset.filterGroup;

                const filterButton = document.querySelector(`.filter-button[data-filter-trigger="${groupName}"]`);
                if (!filterButton) return;

               
            });

            // APPLY BUTTON
            const applyButton = filterGroup.querySelector('.Both_combined_buttons .apply_buttons');
            if (applyButton) {
                applyButton.addEventListener('click', () => {
                    console.log('Apply button clicked');

                        const filterGroup = applyButton.closest('.filter-drawer-group');
                        if (!filterGroup) return;
                        const filterGroupName = filterGroup.dataset.filterGroup;
                        if (!filterGroupName) return;
                        const blogFilterContainer = document.querySelector('.blog-filter-container');
                        if (!blogFilterContainer) return;
                         const filter_buttons_all = blogFilterContainer.getElementsByClassName('filter-button');
                         for (let i = 0; i < filter_buttons_all.length; i++) {
                            const btn = filter_buttons_all[i];
                            if (btn.classList.contains('filter-all') && btn.classList.contains('active')) {
                                btn.classList.remove('filter-all', 'active');
                                console.log("Removed 'active' from:", btn);
                            }
                        }
                        const filterButton = blogFilterContainer.querySelector(
                            `.both_combined_filter .filter-button[data-filter-trigger="${filterGroupName}"]`
                        );
                        if (filterButton) {
                            filterButton.classList.add('active');
                        }
                        


                    if (selectedFilters.length === 0) {
                        this.closeDrawer();
                        return;
                    }
                      
                    this.updateGroupedFilters();

                    const encodedTags = selectedFilters.map(tag => encodeURIComponent(tag)).join('+');
                    const newURL = `${window.location.pathname}?tags=${encodedTags}`;
                    history.pushState({ tags: selectedFilters }, '', newURL);
                    // this.toggleLoaderByURL();   
                    this.applyFiltering();
                    this.closeDrawer();
                });
            }

            // RESET BUTTON
            const resetButton = filterGroup.querySelector('.Both_combined_buttons .reset_buttons');
            if (resetButton) {
                resetButton.addEventListener('click', () => {
                    console.log('Reset button clicked');
                    

                    let prefixToRemove = '';
                    if (filterType === 'categories') prefixToRemove = 'category_';
                    else if (filterType === 'concerns') prefixToRemove = 'concern_';
                    else if (filterType === 'ingredients') prefixToRemove = 'ingredients_';

                    selectedFilters = selectedFilters.filter(tag => !tag.startsWith(prefixToRemove));
                    this.updateGroupedFilters();
                    const allFilterButton = document.querySelector('.blog-filter-container .filter-button');
                    filterGroup.querySelectorAll('.filter-drawer-item').forEach(item => {
                        const input = item.querySelector('input[type="checkbox"]');
                        if (input && input.value.startsWith(prefixToRemove)) {
                            input.checked = false;
                            item.classList.remove('active');
                        }
                    });

                    if (selectedFilters.length === 0) {
                        history.pushState({}, '', window.location.pathname);
                        $('.blog-articles__article').show();
                        $('.current-tags').hide();
                        if (allFilterButton) {
                            allFilterButton.classList.add('filter-all','active');
                        }

                    } else {
                        const encodedTags = selectedFilters.map(tag => encodeURIComponent(tag)).join('+');
                        const newURL = `${window.location.pathname}?tags=${encodedTags}`;
                        history.pushState({ tags: selectedFilters }, '', newURL);
                        // this.toggleLoaderByURL();
                        this.applyFiltering();
                    }

                    this.updateTriggerActiveState(trigger, filterType);
                    this.closeDrawer();
                });
            }
        });
    }

    updateGroupedFilters() {
        categoryFilters = selectedFilters.filter(t => t.startsWith('category_'));
        console.log("categoryFilters----" + categoryFilters);

        concernFilters = selectedFilters.filter(t => t.startsWith('concern_'));
        console.log("concernFilters----" + concernFilters);
        ingredientsFilters = selectedFilters.filter(t => t.startsWith('ingredients_'));
        console.log("ingredientsFilters-----" + ingredientsFilters);
        const categoryFilters_1 = categoryFilters.length;
        console.log(categoryFilters_1)
        const concernFilters_1 = concernFilters.length;
        console.log(concernFilters_1);
        const ingredientsFilters_1 = ingredientsFilters.length;
        console.log(ingredientsFilters_1);
    }
    applyFiltering() {
        $('.main-blog').addClass('loading');

        const hasCategory = categoryFilters.length > 0;
        const hasConcern = concernFilters.length > 0;
        const hasIngredients = ingredientsFilters.length > 0;

        $('.blog-articles__article').each(function () {
            const $article = $(this);
            const tagsStr = $article.attr('data-tags') || '';
            const articleTags = tagsStr ? tagsStr.split('|') : [];

            const categoryMatch = !hasCategory || categoryFilters.some(f => articleTags.includes(f));
            const concernMatch = !hasConcern || concernFilters.some(f => articleTags.includes(f));
            const ingredientsMatch = !hasIngredients || ingredientsFilters.some(f => articleTags.includes(f));

            $article.toggle(categoryMatch && concernMatch && ingredientsMatch);
        });

        $('.main-blog').removeClass('loading');
    }

    updateTriggerActiveState(trigger, filterType) {
        let prefix = '';
        if (filterType === 'categories') prefix = 'category_';
        else if (filterType === 'concerns') prefix = 'concern_';
        else if (filterType === 'ingredients') prefix = 'ingredients_';

        const hasActive = selectedFilters.some(t => t.startsWith(prefix));
        trigger.classList.toggle('active', hasActive);
    }

    loadFiltersFromURL() {
        // this.toggleLoaderByURL();
        const params = new URLSearchParams(window.location.search);
        let tagsParam = params.get('tags');

        if (!tagsParam) {
            $('.blog-articles__article').show();
            $('.current-tags').hide();
            return;
        }

        selectedFilters = tagsParam
            .split(/[\s+]+/) // split on spaces OR +
            .map(t => t.trim())
            .filter(Boolean);

        this.updateGroupedFilters();

        selectedFilters.forEach(tag => {
            const checkbox = document.querySelector(`input[type="checkbox"][value="${tag}"]`);
            if (checkbox) {
                checkbox.checked = true;
                checkbox.closest('.filter-drawer-item')?.classList.add('active');
            }
        });

        this.filterTriggers.forEach(trigger => {
            this.updateTriggerActiveState(trigger, trigger.dataset.filterTrigger);
        });

        this.applyFiltering();
        $('.current-tags').show();
         const allFilterButton = document.querySelector('.blog-filter-container .filter-button');
            if (allFilterButton) {
                if (selectedFilters.length > 0) {
                    allFilterButton.classList.remove('filter-all', 'active');
                } else {
                    allFilterButton.classList.add('filter-all', 'active');
                }
            }
    }

    setupInfiniteScrollObserver() {
        if (!this.articlesContainer) {
            console.warn('Articles container not found for infinite scroll observer');
            return;
        }

        this.mutationObserver = new MutationObserver(() => {
            clearTimeout(this.filterTimeout);
            this.filterTimeout = setTimeout(() => {
                this.applyFiltering();
            }, 100);
        });

        this.mutationObserver.observe(this.articlesContainer, {
            childList: true,
            subtree: true
        });
    }

    destroy() {
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
    }
}

/* INIT */
document.addEventListener('DOMContentLoaded', () => {
    window.blogFilterDrawer = new BlogFilterDrawer();
});

/* Shopify Theme Editor Support */
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
        if (window.blogFilterDrawer) {
            window.blogFilterDrawer.destroy(); // Clean previous
        }
        window.blogFilterDrawer = new BlogFilterDrawer();
    });
}
